import { useRef } from 'react';

/**
 * abstraction on top of useRef, providing a "self"-object that can provide a
 * stateless context for the component lifecycle (similar to the way that we
 * used to be able to store properties on "this.myProp" in class based
 * components).
 */
function useSelf(initialValue) {
  return useRef(initialValue).current;
}

export { useSelf };
//# sourceMappingURL=useSelf.js.map
